import component from './BillingInfo.vue'
export default component
